// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1__a10f19c7082056e967fb","cls2":"SearchBar-cls2___ad352247d246a8ae2ae SearchBar-cls1__a10f19c7082056e967fb"};